import React from "react";
import Reveal from "../Reveal";
import { TEAM } from "../../mock";

const TeamMember = ({ member, idx }) => (
  <Reveal>
    <div
      className={`team-card grid md:grid-cols-12 gap-8 md:gap-14 items-center ${
        idx % 2 === 1 ? "md:[direction:rtl]" : ""
      }`}
    >
      <div className="md:col-span-5 [direction:ltr]">
        <div className="overflow-hidden rounded-sm shadow-[0_30px_60px_-25px_rgba(58,55,54,0.5)] bg-[#b6a4a7]">
          <img
            src={member.img}
            alt={`${member.first} ${member.last}`}
            className="team-photo w-full h-[420px] md:h-[500px] object-cover object-top"
          />
        </div>
      </div>
      <div className="md:col-span-7 [direction:ltr]">
        <h3 className="brand-title text-4xl md:text-5xl text-[#3a3736] uppercase">{member.first}</h3>
        <h3 className="brand-title text-4xl md:text-5xl text-[#b6a4a7] uppercase -mt-1">{member.last}</h3>
        <p className="font-sans-el tracking-[0.25em] uppercase text-[#9a878b] text-xs mt-3 mb-5">{member.role}</p>
        <p className="font-serif-el text-lg md:text-xl leading-relaxed text-[#4a4644]">{member.bio}</p>
      </div>
    </div>
  </Reveal>
);

const TeamSection = () => (
  <section className="bg-[#f6f2ed] py-20 md:py-28">
    <div className="max-w-[1300px] mx-auto px-6">
      <Reveal className="text-center mb-16">
        <p className="font-sans-el tracking-[0.4em] uppercase text-[#9a878b] text-xs mb-4">
          The People Behind Your Move
        </p>
        <h2 className="section-title text-4xl md:text-5xl text-[#3a3736]">Meet The Team</h2>
        <div className="divider-ornament mt-6">
          <span className="line" /><span className="dot" /><span className="line" />
        </div>
      </Reveal>

      <div className="space-y-20 md:space-y-28">
        {TEAM.map((member, idx) => (
          <TeamMember key={member.id} member={member} idx={idx} />
        ))}
      </div>
    </div>
  </section>
);

export default TeamSection;
